module.exports = __webpack_public_path__ + "way2go/static/config/aircraft_bay_pushback_mapping.csv";